import {Component, Inject} from "@angular/core";
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator} from 'prod-form';
import {BatteryEventTypeService} from "../../../../../services/battery-event-type.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ProdDialogData} from 'prod-dialog';
import {DeviceEventService} from "../../../../../services/device-event.service";
import {CarFormComponent} from "../../car-form.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-battery-events-form',
  templateUrl: './battery-events-form.html'
})
export class BatteryEventsForm extends AbstractProdForm {
  title: string = this.translate.instant('cars.battery_events.form.title');
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'type',
      label: this.translate.instant('cars.battery_events.form.type'),
      type: ProdFormFieldType.SELECT,
      selectParameters: {
        selectDataService: BatteryEventTypeService,
        isMulti: false,
        isNarrowDown: true,
        isComplete: true
      },
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: false
    }),
    ProdFormField.create({
      name: 'batteryEvent_createdAt',
      label: this.translate.instant('cars.battery_events.form.created_at'),
      type: ProdFormFieldType.DATETIME,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: false
    }),
    ProdFormField.create({
      name: 'batteryEvent_voltage',
      label: this.translate.instant('cars.battery_events.form.voltage'),
      type: ProdFormFieldType.NUMBER,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: false
    }),
    ProdFormField.create({
      name: 'batteryEvent_description',
      label: this.translate.instant('cars.battery_events.form.description'),
      type: ProdFormFieldType.TEXTAREA,
    }),
    ProdFormField.create({
      name: 'carId',
      label: '',
      type: ProdFormFieldType.HIDDEN,
      value: CarFormComponent.carId
    })
  ]

  constructor(
    dialogRef: MatDialogRef<BatteryEventsForm>,
    @Inject(MAT_DIALOG_DATA) public dialogData: ProdDialogData,
    override dataService: DeviceEventService,
    private translate: TranslateService) {
    super();
  }
}
